
import React from 'react';
import { 
  AlertDialog, 
  AlertDialogContent, 
  AlertDialogHeader, 
  AlertDialogTitle, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogAction,
  AlertDialogCancel
} from "@/components/ui/alert-dialog";

interface NewChatDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const NewChatDialog: React.FC<NewChatDialogProps> = ({ isOpen, onOpenChange, onConfirm }) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-gray-900 border border-gray-700 text-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Neue Konversation starten?</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-300">
            Dies wird Ihre aktuelle Konversation beenden und eine neue starten.
            Nicht gespeicherte Änderungen gehen verloren.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-jade hover:bg-jade-light text-white"
          >
            Neue Konversation starten
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

interface HelpDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const HelpDialog: React.FC<HelpDialogProps> = ({ isOpen, onOpenChange }) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-gray-900 border border-gray-700 text-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Hilfe & Support</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-300">
            <div className="space-y-4 mt-2">
              <div>
                <h3 className="font-medium text-white mb-1">Kontakt</h3>
                <p>Senden Sie eine E-Mail an support@reactmail.ai</p>
              </div>
              <div>
                <h3 className="font-medium text-white mb-1">Dokumentation</h3>
                <p>Besuchen Sie unsere <a href="#" className="text-jade underline">Online-Dokumentation</a> für Anleitungen und Tutorials.</p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction 
            onClick={() => onOpenChange(false)}
            className="bg-jade hover:bg-jade-light text-white"
          >
            Schließen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

interface DeleteChatDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({ isOpen, onOpenChange, onConfirm }) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-gray-900 border border-gray-700 text-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Chat löschen?</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-300">
            Möchten Sie diese Konversation wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex justify-end gap-2">
          <AlertDialogCancel className="bg-gray-700 hover:bg-gray-600 text-white border-none">
            Abbrechen
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Löschen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
